// check opening-hours orb on time
$('.open-hours--open').each(function() {

    let $elem = $(this),
        currentTime = moment(),
        openFrom = moment($elem.data('open-from'), 'HH:mm'),
        openTo= moment($elem.data('open-to'), 'HH:mm'),
        $orb = $elem.find('.open-hours__orb'),
        $text = $elem.find('.open-hours__text'),
        classOrbClosed = 'open-hours__orb--closed';

    if (currentTime.isBefore(openFrom)) { // check if current time is before opening
        if (!$orb.hasClass(classOrbClosed)) {
            $orb.addClass(classOrbClosed);
            $text.html($text.data('opening-text'));
        }
    } else if (currentTime.isAfter(openTo)) { // check if current time is after closing
        if (!$orb.hasClass(classOrbClosed)) {
            $orb.addClass(classOrbClosed);
            $text.html($text.data('closed-text'));
        }
    } else {
        // current time is open
    }

});